import { bisector, range as d3Range, bisectLeft } from 'd3';
// Make more robust to null/undefined scaled values
/** Finds the nearest datum in a single direction (x or y) closest to the specified `scaledValue`. */
export default function findNearestDatumSingleDimension(_ref) {
  let {
    scale,
    accessor,
    scaledValue,
    data
  } = _ref;
  const coercedScale = scale; // broaden type before type guards below

  let nearestDatum;
  let nearestDatumIndex;
  // if scale has .invert(), convert svg coord to nearest data value
  if ('invert' in coercedScale && typeof coercedScale.invert === 'function') {
    const bisect = bisector(accessor).left;
    // find closest data value, then map that to closest datum
    const dataValue = Number(coercedScale.invert(scaledValue));
    const index = bisect(data, dataValue);
    // take the two datum nearest this index, and compute which is closer
    const nearestDatum0 = data[index - 1];
    const nearestDatum1 = data[index];
    nearestDatum = !nearestDatum0 || Math.abs(dataValue - accessor(nearestDatum0)) > Math.abs(dataValue - accessor(nearestDatum1)) ? nearestDatum1 : nearestDatum0;
    nearestDatumIndex = nearestDatum === nearestDatum0 ? index - 1 : index;
  } else if ('step' in coercedScale && typeof coercedScale.step !== 'undefined') {
    // band scales don't have an invert function but they do have discrete domains
    // so we manually invert
    const domain = scale.domain();
    const range = scale.range().map(Number);
    // Remove the padding for the points

    // https://github.com/airbnb/visx/issues/1602
    // Need to consider

    const sortedRange = [...range].sort((a, b) => a - b); // bisectLeft assumes sort
    const sortedDomain = range[0] < range[1] ? domain : domain.reverse();
    let domainValue = 0;
    if ('paddingInner' in scale) {
      // BandScale

      // Get the outer padding.
      const paddingOuter = scale(sortedDomain[0]) || 0;
      // Get each band size
      const eachBand = coercedScale.step();
      // Find the index
      const index = Math.floor((scaledValue - paddingOuter) / eachBand);
      // Get domain value
      domainValue = sortedDomain[Math.max(0, Math.min(index, sortedDomain.length - 1))];
    } else {
      // PointScale

      // Create ranges that take into account the padding of the first and last
      // elements. Basically if there is 0 padding then the first element
      // should go into the negative by 1/2 the step amount.
      const rangePoints = d3Range(sortedRange[0] - coercedScale.step() * (0.5 - coercedScale.padding()), sortedRange[1] + coercedScale.step() * (0.5 - coercedScale.padding()), coercedScale.step());
      domainValue = sortedDomain[bisectLeft(rangePoints, scaledValue) - 1];
    }
    const index = data.findIndex(d => String(accessor(d)) === String(domainValue));
    nearestDatum = data[index];
    nearestDatumIndex = index;
  } else {
    console.warn('[visx/xychart/findNearestDatum] encountered incompatible scale type, bailing');
    return null;
  }
  if (nearestDatum == null || nearestDatumIndex == null) return null;
  const distance = Math.abs(Number(coercedScale(accessor(nearestDatum))) - scaledValue);
  return {
    datum: nearestDatum,
    index: nearestDatumIndex,
    distance
  };
}